import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import {
  loadProcessList,
  loadSelectedProcessSuccess,
  setLoadingProcess
} from "../../../infrastructure/store/process/process.actions";
import {ProcessFilterType, ProcessI} from "../../../infrastructure/interfaces/process.interface";
import {selectLoadingProcess, selectProcessList} from "../../../infrastructure/store/process/process.selector";
import {Router} from "@angular/router";
import {itemsPerPageList} from "../../../infrastructure/store/process-result/state";
import {setSearchParameters} from "../../../infrastructure/store/process-result/process-result.actions";
import {LocalStorageService} from "../../../infrastructure/services/local-storage.service";

@Component({
  selector: 'app-process-model-grid',
  templateUrl: './process-model-grid.component.html',
  styleUrls: ['./process-model-grid.component.scss']
})
export class ProcessModelGridComponent implements OnInit, OnDestroy{
  destroy$ = new Subject<void>()

  loadingProcess: boolean = false;

  processList: ProcessI[] = [];

  constructor(
    private store: Store,
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {
    this.store.dispatch(setLoadingProcess({status: true}));
    this.store.dispatch(loadProcessList())
  }

  ngOnInit() {
    this.store.select(selectProcessList).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.processList = value;
    })

    this.store.select(selectLoadingProcess).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.loadingProcess = value;
    })
  }

  selectProcess(process: ProcessI){
    this.buildSearchParameters(process);
    this.store.dispatch(loadSelectedProcessSuccess({process: process}));
    this.router.navigate(['/process', process.id, 'process-results'])
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  buildSearchParameters(processModel: ProcessI | null){
    if (processModel) {
      console.log("building default filters...")


      let dynamicFilters: any = {};
      //Dynamic filters
      if (processModel.process_filters){
        // Initialize dynamic default values
        processModel.process_filters.forEach((filter) => {
          let default_value = filter.default || null;
          if (filter.type === ProcessFilterType.date && default_value === 'today'){
            default_value = new Date().toISOString().split("T")[0]
          }
          dynamicFilters[filter.field] = default_value
        })
      }

      const searchParameters = {
        initial: false,
        orderBy: processModel.tableDashboard?.defaultSort?.orderBy || null,
        order: processModel.tableDashboard?.defaultSort?.order || 'asc',
        search: null,
        bookmarked_filter: "inactive",
        process_status_filter: processModel.process_states.states_list
          .filter((k) => k.selected)
          .reduce((acc: string[], curr) => {
            acc.push(curr.key)
            return acc
          }, []).join(","),
        process_tasks_filter: processModel.tasks
          .filter((v)=>v?.selected)
          .reduce((acc: string[], curr) => {
            acc.push(curr.id);
            return acc
          },[]).join(","),
        dynamic_filter: dynamicFilters,
        entries: this.localStorageService.getItemPerPage() || itemsPerPageList[0].value,
        page: 1
      }

      this.store.dispatch(setSearchParameters({value: searchParameters}))
    }
  }
}
